/* Opens product media in GLightbox when clicking the main image.
   Active when the section setting "Enable product media gallery lightbox" is on
   (media divs get the `glightbox` class in product-thumbnail.liquid). */
(function () {
  'use strict';

  var lightboxHTML =
    '<div id="glightbox-body" class="glightbox-container">' +
    '<div class="gloader visible"></div>' +
    '<div class="goverlay"></div>' +
    '<div class="gcontainer">' +
    '<div id="glightbox-slider" class="gslider"></div>' +
    '<button class="gnext gbtn" tabindex="0" aria-label="Next">{nextSVG}</button>' +
    '<button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>' +
    '<button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>' +
    '</div></div>';

  function getSrc(img) {
    return img.getAttribute('src') || img.currentSrc;
  }

  document.addEventListener('click', function (e) {
    var media = e.target.closest('.product__media.glightbox');
    if (!media) return;
    if (typeof GLightbox === 'undefined') return;

    e.preventDefault();

    var scope =
      media.closest('media-gallery') ||
      media.closest('.product__media_container') ||
      document;

    // Collect gallery images in DOM order, dedupe slider clones by src
    var elements = [];
    var seen = {};
    scope.querySelectorAll('.product__media.glightbox img').forEach(function (img) {
      var src = getSrc(img);
      if (!src || seen[src]) return;
      seen[src] = true;
      elements.push({ href: src, type: 'image' });
    });
    if (!elements.length) return;

    var clickedImg = media.querySelector('img');
    var startIndex = 0;
    if (clickedImg) {
      var clickedSrc = getSrc(clickedImg);
      elements.some(function (el, i) {
        if (el.href === clickedSrc) {
          startIndex = i;
          return true;
        }
        return false;
      });
    }

    var lightbox = GLightbox({
      elements: elements,
      lightboxHTML: lightboxHTML,
      touchNavigation: true,
      loop: true,
      zoomable: true,
      openEffect: 'zoom',
      closeEffect: 'zoom'
    });
    lightbox.openAt(startIndex);
  });
})();
